import { createFileRoute } from '@tanstack/react-router';
import { CobrancaCartaoFormPage } from '@/features/cobranca-cartao/page/CobrancaCartaoForm/CobrancaCartaoFormPage';

export const Route = createFileRoute('/a/cobranca-cartao/cadastrar')({
    component: CobrancaCartaoFormPage,
});
